import { render, staticRenderFns } from "./station.vue?vue&type=template&id=edc2310e&scoped=true"
import script from "./station.vue?vue&type=script&lang=js"
export * from "./station.vue?vue&type=script&lang=js"
import style0 from "./station.vue?vue&type=style&index=0&id=edc2310e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc2310e",
  null
  
)

export default component.exports